import { useGql } from '#imports'
import { getSdk as defaultGqlSdk } from '#gql/default'
export const GqlSdks = {
  default: defaultGqlSdk,
}
export const GqClientOps = {"default":["NavigationsAndGlobals"]}
export const GqlNavigationsAndGlobals = (...params) => useGql()('NavigationsAndGlobals', ...params)